export * from './saveAs';

/**
 * Normalize text into safe filename.
 * @param {string} input
 */
export function normalizeFilename( input ) {
	const pattern = /[^a-zA-Z0-9._-]/g;
	input = input.toLowerCase().replaceAll( pattern, '_' );
	input = input.replaceAll( '__', '_' );
	return input;
}